import {Component} from "../../../gvf/js/component";
import {ObjectService} from "../../js/object-service";

export class DetailObjectButton extends Component{
    constructor(scope,$root){
        super(scope,$root);
    }

    ready(){
        super.ready();
        this.$root.click(
            (ev) => {
                ev.preventDefault();
                ev.stopPropagation();
                const $button = $(ev.currentTarget);
                this.$root.addClass("is-loading");
                const service = new ObjectService($button.data("model"));
                service.openDetailModal({
                    objectId:$button.data("object-id"),
                    editMode:$button.data("edit-mode"),
                    lang:$button.data("lang"),
                    data:$button.data("data"),
                    saveCallback: (resp)=>{
                        if(resp.message){
                            this.alertEndpointResponse(resp);
                        }

                        if(resp.url){
                            window.location = resp.url;
                        }else{
                            this.$root.trigger("detailObjectButton:saved");
                        }
                    },
                    deleteCallback: (resp)=>{
                        if(resp.message){
                            this.alertEndpointResponse(resp);
                        }

                        if(resp.url){
                            window.location = resp.url;
                        }else{
                            this.$root.trigger("detailObjectButton:deleted");
                        }
                    }
                });
            }
        );
    }
}

